import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import WorkMedia from '../components/WorkMedia';
import { PlaceholderImage } from '../components/PlaceholderMedia';
import workData from '../data/work.json';

const Work = () => {
  const [firstItem, ...restItems] = workData;

  return (
    <main className="main-wrapper">
      <div className="work-left"></div>
      <div className="main-wrapper-right">
        <section className="section-work-projects">
          <div className="page-heading">
            <h1 className="heading-style-h1">Work</h1>
            <div className="page-heading-bottom">
              <div className="max-width-medium">
                <div className="text-size-medium">
                  My work is built on craft, technical excellence, and a drive to create experiences that genuinely engage people - from live events in the Metaverse to award-winning AR campaigns and interactive installations.
                </div>
              </div>
              <a href="#work-projects-mobile" className="button-scroll w-inline-block">
                <div className="button-scroll-inner">
                  <div className="button-scroll-inner-text">Explore</div>
                  <div className="button-scroll-inner-text-hover">Explore</div>
                </div>
                <div className="button-scroll-icon-wrapper w-embed">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                    <path d="M205.66,149.66l-72,72a8,8,0,0,1-11.32,0l-72-72a8,8,0,0,1,11.32-11.32L120,196.69V40a8,8,0,0,1,16,0V196.69l58.34-58.35a8,8,0,0,1,11.32,11.32Z"></path>
                  </svg>
                </div>
              </a>
            </div>
          </div>
          <div id="work-projects" className="work-projects">
            <div className="work-projects-desktop">
              <div className="work-projects-list">
                {firstItem ? (
                  <div className="project-preview-small-first">
                    <Link to={`/work/${firstItem.slug}`} className="project-preview-small-link w-inline-block">
                      <h2 className="heading-style-h5">{firstItem.title}</h2>
                      <div className="project-preview-small-meta">
                        <div className="text-meta">{firstItem.category}</div>
                        <div className="text-meta">{firstItem.year}</div>
                      </div>
                    </Link>
                    <div className="project-preview-small-first-image-wrapper">
                      <div className="project-preview-small-first-image-wrapper-inner">
                        <div className="card-corner-bottom-right">
                          <div className="text-meta">{firstItem.category}</div>
                          <div className="corner-bottom-right top w-embed">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                            </svg>
                          </div>
                          <div className="corner-bottom-right bottom w-embed">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                            </svg>
                          </div>
                        </div>
                        <WorkMedia media={firstItem.media} className="project-preview-small-first-image" />
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="work-projects-desktop">
              <div className="work-projects-list">
                {restItems.map((item) => (
                  <div key={item.slug} className="project-preview-small">
                    <Link to={`/work/${item.slug}`} className="project-preview-small-link w-inline-block">
                      <h2 className="heading-style-h5">{item.title}</h2>
                      <div className="project-preview-small-meta">
                        <div className="text-meta">{item.category}</div>
                        <div className="text-meta">{item.year}</div>
                      </div>
                    </Link>
                    <div className="project-preview-small-image-wrapper">
                      <div className="project-preview-small-image-wrapper-inner">
                        <div className="card-corner-bottom-right">
                          <div className="text-meta">{item.category}</div>
                          <div className="corner-bottom-right top w-embed">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                            </svg>
                          </div>
                          <div className="corner-bottom-right bottom w-embed">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                            </svg>
                          </div>
                        </div>
                        <WorkMedia media={item.media} className="project-preview-small-image" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="work-projects-mobile">
              <div id="work-projects-mobile" className="work-projects-mobile-grid">
                {workData.map((item) => (
                  <div key={`mobile-${item.slug}`} className="project-preview">
                    <Link to={`/work/${item.slug}`} className="project-preview-image-wrapper w-inline-block">
                      <div className="view-button-wrapper">
                        <div className="view-button">
                          <div className="view-button-icon w-embed">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                              <path d="M198,64V168a6,6,0,0,1-12,0V78.48L68.24,196.24a6,6,0,0,1-8.48-8.48L177.52,70H88a6,6,0,0,1,0-12H192A6,6,0,0,1,198,64Z"></path>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="project-preview-content">
                        <h3 className="text-meta">{item.title}</h3>
                        <div className="corner-top-left top w-embed">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                          </svg>
                        </div>
                        <div className="corner-top-left bottom w-embed">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                          </svg>
                        </div>
                      </div>
                      <PlaceholderImage className='project-preview-image' src={item.media.poster} alt={item.media.alt || ''} loading="lazy" />
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </main>
  );
};

export default Work;

